var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"time-tracking-estimate-only-pane"},[_c('span',{staticClass:"bold"},[_vm._v("\n    "+_vm._s(_vm.s__('TimeTracking|Estimated:'))+"\n  ")]),_vm._v("\n  "+_vm._s(_vm.timeEstimateHumanReadable)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }